/* @flow */
const prefix = str => `station/display/${str}`;

export const STORE_SCROLL_POSITION = prefix('STORE_SCROLL_POSITION');

export const SET_DETAIL_PANEL_OPTIONS = prefix('SET_DETAIL_PANEL_OPTIONS');



// WEBPACK FOOTER //
// ./src/app/modules/display/action-types.js